import script from "./PaginationComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationComponent.vue?vue&type=script&setup=true&lang=js"

import "./PaginationComponent.vue?vue&type=style&index=0&id=4573ec14&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4573ec14"]])

export default __exports__